export default function getResource(label) {
    const resources = {
        retry: 'Réessayer',
        loading: 'Chargement de l’historique annuel',
        shopNow: 'Magasiner'
    };

    return resources[label];
}
